/* SPORT.FR — Theme JS */

// ---- Mobile nav toggle ----
function toggleMobileNav(btn) {
  var nav = document.getElementById('mobile-nav');
  if (!nav) return;
  var exp = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', exp ? 'false' : 'true');
  nav.hidden = exp;
}
// ---- Mobile accordion ----
function toggleMobileAccordion(btn) {
  var panel = btn.nextElementSibling;
  if (!panel) return;
  var exp = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', exp ? 'false' : 'true');
  panel.hidden = exp;
}

// ---- Mega menu hover avec délai de grâce 200ms ----
(function () {
  document.querySelectorAll('.site-nav__item--mega').forEach(function (item) {
    var menu = item.querySelector('.mega-menu');
    if (!menu) return;
    var t;
    function open()  { clearTimeout(t); menu.classList.add('mega-visible');    item.classList.add('mega-open'); }
    function close() { t = setTimeout(function () { menu.classList.remove('mega-visible'); item.classList.remove('mega-open'); }, 200); }
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', close);
  });
})();

// =========================================
// HOMEPAGE
// =========================================
(function () {
  var isHome = document.body.classList.contains('template-index');

  // --- 1. Variable CSS hauteur annonce ---
  var ann = document.getElementById('announcement-bar');
  function setAnnH() {
    var h = ann ? Math.round(ann.getBoundingClientRect().height) : 40;
    document.documentElement.style.setProperty('--ann-h', h + 'px');
  }
  setAnnH();
  window.addEventListener('resize', setAnnH, { passive: true });

  if (!isHome) return;

  // --- 2. Header transparent → opaque au scroll ---
  var header = document.getElementById('site-header');
  var hero   = document.querySelector('.hero');
  if (header && hero) {
    function checkHeader() {
      var threshold = hero.offsetTop + hero.offsetHeight - 80;
      header.classList.toggle('header--scrolled', window.scrollY >= threshold);
    }
    window.addEventListener('scroll', checkHeader, { passive: true });
    checkHeader();
  }

  // --- 3. Image hero fixée ---
  // L'image reste fixe dans le viewport.
  // Quand le hero est complètement scrollé au-dessus du viewport,
  // on la repasse en absolute pour qu'elle ne reste pas visible
  // derrière le footer.
  if (!hero) return;
  var heroBg = hero.querySelector('.hero__bg');
  if (!heroBg) return;

  function updateHeroBg() {
    var rect = hero.getBoundingClientRect();
    if (rect.bottom <= 0) {
      // Hero sorti du viewport : reset en absolute (reste dans le hero)
      heroBg.style.position  = 'absolute';
      heroBg.style.top       = '0';
      heroBg.style.height    = '100%';
    } else {
      // Hero visible : image fixée dans le viewport
      // (position:fixed déjà définie par CSS .template-index .hero__bg)
      heroBg.style.position  = '';
      heroBg.style.top       = '';
      heroBg.style.height    = '';
    }
  }
  window.addEventListener('scroll', updateHeroBg, { passive: true });
  updateHeroBg(); // Vérification initiale

})();

// =========================================
// PAGE PRODUIT
// =========================================
document.addEventListener('DOMContentLoaded', function () {

  // Variantes
  var variantDataEl = document.getElementById('product-variants-json');
  if (variantDataEl) {
    var variants = JSON.parse(variantDataEl.textContent);
    var variantInput = document.getElementById('variant-id');
    var priceEl = document.getElementById('product-price');
    var atcBtn  = document.querySelector('.product-atc__btn');
    var selOpts = [];
    document.querySelectorAll('.product-option__values').forEach(function (g) {
      var a = g.querySelector('.product-option__value--active');
      if (a) selOpts.push(a.dataset.value);
    });
    document.querySelectorAll('.product-option__value').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(this.dataset.optionIndex);
        selOpts[idx] = this.dataset.value;
        this.closest('.product-option__values').querySelectorAll('.product-option__value').forEach(function (b) { b.classList.remove('product-option__value--active'); });
        this.classList.add('product-option__value--active');
        var found = variants.find(function (v) { return v.options.every(function (o, i) { return o === selOpts[i]; }); });
        if (found) {
          if (variantInput) variantInput.value = found.id;
          if (priceEl) priceEl.textContent = fmtMoney(found.price);
          if (atcBtn) { atcBtn.disabled = !found.available; atcBtn.textContent = found.available ? 'Ajouter au panier' : 'Indisponible'; }
          var bp = document.querySelector('.mobile-atc-bar__product-price');
          if (bp) bp.textContent = fmtMoney(found.price);
        }
      });
    });
  }
  function fmtMoney(c) { return (c/100).toLocaleString('fr-FR',{style:'currency',currency:'EUR'}); }

  // Mobile ATC bar
  var bar  = document.getElementById('mobile-atc-bar');
  var form = document.getElementById('product-form');
  if (bar && form) {
    var tEl = document.querySelector('.product-info__title');
    var pEl = document.querySelector('.product-info__price');
    var bt  = bar.querySelector('.mobile-atc-bar__product-title');
    var bp2 = bar.querySelector('.mobile-atc-bar__product-price');
    var bb  = bar.querySelector('.mobile-atc-bar__btn');
    if (tEl && bt) bt.textContent = tEl.textContent;
    if (pEl && bp2) bp2.textContent = pEl.textContent;
    if (bb) bb.addEventListener('click', function () { var s = form.querySelector('[type=submit]'); if (s) s.click(); });
    var sub = form.querySelector('[type=submit]');
    if (sub && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { e.forEach(function (x) { bar.hidden = x.isIntersecting; }); }, { threshold: 0.1 }).observe(sub);
      bar.hidden = false;
    }
  }

});